import { render, staticRenderFns } from "./LoaderScreen.vue?vue&type=template&id=8c55018a"
import script from "./LoaderScreen.vue?vue&type=script&lang=js"
export * from "./LoaderScreen.vue?vue&type=script&lang=js"
import style0 from "./LoaderScreen.vue?vue&type=style&index=0&id=8c55018a&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports